import React from 'react';
import * as Mui from '@mui/material';

const RouteLoader = ({
  open,
  label = 'Please wait...',
}) => (
  <Mui.Fade in={open} mountOnEnter unmountOnExit timeout={{ enter: 120, exit: 120 }}>
    <Mui.Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1500,
        display: 'grid',
        placeItems: 'center',
        pointerEvents: 'none',
      }}
    >
      <Mui.CircularProgress color="primary" aria-label={label} />
    </Mui.Box>
  </Mui.Fade>
);

export default RouteLoader;
